import { Translation } from "../hooks/useTranslations";

export const formatBoolean = (translations: Translation, value?: boolean): string =>
  value ? translations.common.yes : translations.common.no;

export const formatTimestampLong = (value: string, locale: string | null): string => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  };
  return new Date(value).toLocaleDateString(locale ?? undefined, options);
};

export const formatHours = (value: string, locale: string | null): string => {
  const options: Intl.DateTimeFormatOptions = {
    hour: "numeric",
    minute: "numeric",
  };
  return new Date(value).toLocaleTimeString(locale ?? undefined, options);
};

export const formatTimestampShort = (value: string, locale: string | null): string => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  };
  return new Date(value).toLocaleDateString(locale ?? undefined, options);
};

export const formatDateLong = (value: string, locale: string | null): string => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return new Date(value).toLocaleDateString(locale ?? undefined, options);
};

export const formatDateShort = (value: string, locale: string | null): string => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  };
  return new Date(value).toLocaleDateString(locale ?? undefined, options);
};
